import type { Session, User } from "@supabase/supabase-js"
import { useSyncExternalStore } from "react"
import { supabase } from "@/lib/supabase"

type AuthState = {
	session: Session | null
	user: User | null
	isLoading: boolean
}

let authState: AuthState = {
	session: null,
	user: null,
	isLoading: true,
}

const listeners = new Set<() => void>()

function notifyListeners() {
	for (const listener of listeners) {
		listener()
	}
}

function setAuthState(newState: Partial<AuthState>) {
	authState = { ...authState, ...newState }
	notifyListeners()
}

async function initAuth(): Promise<void> {
	const {
		data: { session },
	} = await supabase.auth.getSession()
	setAuthState({
		session,
		user: session?.user ?? null,
		isLoading: false,
	})
}

export const initPromise = initAuth()

supabase.auth.onAuthStateChange((_event, session) => {
	setAuthState({
		session,
		user: session?.user ?? null,
		isLoading: false,
	})
})

export function useAuth(): AuthState {
	return useSyncExternalStore(
		(callback) => {
			listeners.add(callback)
			return () => listeners.delete(callback)
		},
		() => authState,
	)
}
